import gsap from 'gsap';
import React, { useEffect, useRef } from 'react';

const SectionTitle = ({ currentSection, sections }) => {
  const containerRef = useRef();
  const titleRef = useRef();
  const descriptionRef = useRef();

  const currentSectionData = sections[currentSection];
  const isDefault = currentSectionData?.name === "DEFAULT";

  const getPositionStyle = (sectionIndex) => {
    switch(sectionIndex) {
      case 0: // First section
        return {
          top: '2rem',
          right: '2rem',
          textAlign: 'left',
          width: '100%'
        };
      case 1: // Second section
        return {
          top: '2rem',
          right: '2rem',
          textAlign: 'left',
          width: '100%'
        };
      case 2: // Third section - keeping original centered style
        return {
          top: '35%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          textAlign: 'center',
          width: '100%'
        };
      case 3: // Fourth section
        return {
          top: '2rem',
          right: '.5rem',
          textAlign: 'left',
          width: '100%'
        };
      case 4: // Fifth section
        return {
          top: '2rem',
          right: '.5rem',
          textAlign: 'left',
          width: '100%'
        };
      case 5: // Sixth section
        return {
          bottom: '2rem',
          left: '2rem',
          textAlign: 'left',
        };
      case 6: // Seventh section
        return {
          top: '2rem',
          left: '2rem',
          textAlign: 'left',
        };
      default:
        return {
          top: '2rem',
          left: '2rem',
          textAlign: 'left',
        };
    }
  };

  useEffect(() => {
    if (!titleRef.current || !descriptionRef.current) return;

    // Kill any existing animations
    gsap.killTweensOf([titleRef.current, descriptionRef.current]);

    // Simple fade in animation for title
    gsap.fromTo(titleRef.current, 
      { opacity: 0, y: 20 }, 
      { opacity: 1, y: 0, duration: 0.8, ease: 'power2.out' }
    );
    
    // Simple fade in animation for description with delay
    gsap.fromTo(descriptionRef.current, 
      { opacity: 0, y: 20 }, 
      { opacity: 1, y: 0, duration: 0.8, delay: 0.2, ease: 'power2.out' }
    );
  }, [currentSection]);

  if (!currentSectionData) return null;

  return (
    <div 
      ref={containerRef}
      style={{
        position: 'fixed',
        ...getPositionStyle(currentSection),
        color: 'white',
        zIndex: 11111111,
        pointerEvents: 'none',
                minWidth: currentSection === 2 ? '100%' : '400px',
        maxWidth: currentSection === 2 ? '100%' : '400px'
      }}
    >
      <h2 
        ref={titleRef}
        style={{
          fontSize: isDefault ? 'clamp(1.5rem, 3vw, 3rem)' : 'clamp(1.2rem, 2.5vw, 2.5rem)',
          fontWeight: 700,
          marginBottom: '1rem',
          textTransform: 'uppercase',
          opacity: 1,
        }}
      >
        {currentSectionData.name === "DEFAULT" ? "Welcome to the Olea Blu Pool Deck" : currentSectionData.name}
      </h2>
      <p 
        ref={descriptionRef}
        style={{
          fontSize: isDefault ? 'clamp(0.8rem, 1.2vw, 1.2rem)' : 'clamp(0.7rem, 1vw, 0.9rem)',
          fontWeight: 300,
          letterSpacing: '0.2em',
          lineHeight: 1.6,
          textTransform: 'uppercase',
          opacity: 1
        }}
      >
        {currentSectionData.name === "DEFAULT" ? "[Look around & Scroll to explore]" : currentSectionData.description}
      </p>
    </div>
  );
};

export default SectionTitle; 